'use strict';
const angular = require('angular');

/*@ngInject*/
export function CommunityService($resource) {
  return $resource('/api/communities/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/communities/:id/attachments"
    }
  });
}


export default angular.module('conduu.CommunityService', [])
  .factory('CommunityService', CommunityService)
  .name;



// WEBPACK FOOTER //
// ./client/components/community/community.service.js